'use client';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputField } from '../input-field/input-field';
import { containsAlphaChars, containsNumericChars } from './utils';

export const ACHName = ({ ...fieldProps }) => {
  const { getValues, setValue } = useFormContext();

  const { t } = useTranslation();

  return (
    <InputField
      autoComplete="off"
      label={t('paymentMethods.ach.fields.name')}
      name="ach-name"
      onBlur={() => {
        setValue(fieldProps.name, getValues(fieldProps.name).trim(), {
          shouldValidate: true,
        });
      }}
      validate={(value: string) =>
        (containsAlphaChars(value) && !containsNumericChars(value)) ||
        t('checkout.form.ach.nameInvalid')
      }
      {...fieldProps}
    />
  );
};
